<template>
  <a-modal
    :visible="visible"
    title="文件上传"
    :width="750"
    :destroy-on-close="true"
    :confirm-loading="confirmLoading"
    :keyboard="false"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-alert
      banner
      type="info"
      style="border-radius: 6px;"
    >
      <template slot="message">
        <span>仅支持上传 Excel 格式的文件。</span>
      </template>
    </a-alert>
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :wrapper-col="{
        span: 20
      }"
      :model="form"
      :rules="rules"
      style="margin-top: 16px"
    >
      <a-form-model-item prop="fileList" label="上传文件" style="margin-bottom: 0;">
        <a-upload-dragger
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          :before-upload="beforeUpload"
          :file-list="form.fileList"
          @change="handleChange"
        >
          <a-icon
            type="cloud-upload"
            style="font-size: 54px; margin: 32px 0 8px; color: #d9d9d9"
          ></a-icon>
          <div style="color: #d9d9d9; margin-bottom: 24px;">点击或拖拽到本区域上传</div>
        </a-upload-dragger>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { importPortMapInventory } from '@/api/inventory.js'

export default {
  name: 'UploadModal',
  data () {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        fileList: []
      },
      rules: {
        fileList: [
          {
            message: '请上传 Excel 文件',
            required: true,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    handleOk () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          const formData = new FormData()
          formData.append('file', ...this.form.fileList)
          importPortMapInventory(formData).then(res => {
            this.$message.success(res.message)
            this.$emit('confirm')
          }).finally(() => {
            this.handleCancel()
          })
        }
      })
    },
    handleCancel () {
      this.confirmLoading = false
      this.visible = false
      this.form = {
        fileList: []
      }
      this.$refs.form.resetFields()
    },
    beforeUpload () {
      return false
    },
    handleChange (info) {
      let fileList = [...info.fileList]
      if (info.file.status === 'removed') this.form.fileList = []
      else fileList = [info.file]
      this.form.fileList = fileList
    }
  }
}
</script>
